module.exports = __webpack_public_path__ + "static/media/vibino-feature-photo effect-pic1.b0fe4397.jpg";